const Footer =(props) => {
  return (
      <div className="col-md-4 offset-md-4 ">
        <div className="footer">{props.footerdata} / &copy; 2016 BUART</div>
      </div>
  );
}
export default Footer;
